<template>
    <div>
        <headerpage :status="0"></headerpage>
    <div class="deground">
        <div class="adaptation" style="background-color: #f6f8f7;">
            <div class="hetext">首页>政策资讯</div>
            <div class="box">
                <div class="box_cet" :class="tabindex==index?'box_sty':''" v-for="(item,index) in tablist"
                    @click="tabchange(index)">
                    {{item.name}}
                </div>
            </div>
            <div class="box1">
                <template v-if="tabindex==0">
                    <consultingpage></consultingpage>
                </template>
                <template v-else>
                    <bulletinpage></bulletinpage>
                </template>
            </div>
        </div>

        <div style="height: 30px;"></div>
    </div>
    </div>
  
</template>
  
<script>
import headerpage from '../../components/header/header.vue';
import bulletin from "./bulletin.vue"
import consulting from "./consulting.vue"
export default {
    components: {
        bulletinpage: bulletin,
        consultingpage: consulting,
        headerpage
    },
    data() {
        return {
            tabindex: 0,
            tablist: [
                {
                    name: '申报'
                },
                {
                    name: '公告'
                }
            ]
        }
    },
    methods: {
        tabchange(index) {
            this.tabindex = index
        }
    },
    created: function () {
    }
}
</script>
<style scoped>
.box {
    height: 77px;
    background-color: #ffffff;
    border-radius: 10px 10px 0px 0px;
    width: 100%;
    display: flex;
    align-items: center;
    /* line-height: 77px; */
    padding: 0 30px;
}

.box_cet {
    width: 120px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.box_sty {
    background-color: #0170c1;
    border-radius: 8px;
    color: #fff;
}

.box1 {
    background-color: #fff;
    margin-top: 10px;
}
.hetext {
    font-size: 15px;
    color: #bdbdbd;
    padding: 16px 0;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// list.vue?3dacfa68